// extracted by mini-css-extract-plugin
export default {"row":"index_row__bmKam","content":"index_content__CrHBh","price":"index_price__8Cji7"};